import React, { useEffect, useState, useContext } from "react";
import { DefaultColumnFilter } from "react-table";

import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Table from "../../Components/Table";

function ListCoupons(props) {
  const apiToken = useContext(TokenContext);
  const [couponsList, setCouponsList] = useState([]);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      id: "1",
      Header: "Cognome e nome",
      Filter: DefaultColumnFilter,
      accessor: (row) => `${row.user.lastName} ${row.user.firstName}`,
      render: (
        column // Assicurati che render sia implementato correttamente
      ) => <input type="text" placeholder="Filtra per cognome e nome" />,
    },
    {
      id: "2",
      Header: "Tipo buono",
      Filter: DefaultColumnFilter,
      accessor: "title",
    },

    {
      id: "3",
      Header: "Valore",
      Filter: DefaultColumnFilter,
      accessor: "valore",
      render: (row) => `${row.valore} €`,
    },
    {
      id: "4",
      Header: "Valido (Da - a)",
      Filter: DefaultColumnFilter,
      accessor: (row) =>
        `(${row.dataInizioValidita} - ${row.dataFineValidita})`,
    },
    {
      id: "5",
      Header: "Utilizzi rimasti",
      Filter: DefaultColumnFilter,
      accessor: "maxMonthlyUsage",
    },
    {
      id: "6",
      Header: "Utilizzato",
      Filter: DefaultColumnFilter,
      accessor: (row) => (row.isUsed ? "Sì" : "No"),
    },
    {
      id: "7",
      Header: "",
      Filter: DefaultColumnFilter,

      accessor: (row) => (
        <button
          className="btn btn-outline-primary p-1"
          data-toggle="tooltip"
          data-placement="top"
          title="Download file"
          onClick={() => viewCoupon(row.id)}
        >
          <svg className="icon icon-primary">
            <use href={`${iconSprite}#it-download`} />
          </svg>
        </button>
      ),
    },
  ];

  const viewCoupon = (id) => {
    Repo.UrlCoupon2(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          const { fileContent, fileName } = response.data;
          const binaryString = window.atob(fileContent);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: "image/png" });

          // Crea un URL temporaneo per il blob
          const imageUrl = URL.createObjectURL(blob);

          // Crea un elemento <a> con l'URL temporaneo e l'attributo download
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = fileName; // Nome del file
          link.click();

          // Rilascia l'URL temporaneo dopo il click
          URL.revokeObjectURL(imageUrl);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setLoading(false);
    Repo.ListCoupon(apiToken, "*")
      .then((response) => {
        setCouponsList(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlertVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  return (
    <>
      <div>
        <h1>Lista buoni servizio</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Tutti i buoni servizio generati dal sistema</p>
        </div>

        {couponsList && couponsList.length > 0 && (
          <Table data={couponsList} columns={columns} />
        )}
      </div>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListCoupons;
